import { Icon, IconVariant } from '@/components/Icon';
import { Richtext } from '@/components/Richtext';
import classnames from '@/utilities/classnames';
import React, { ReactNode } from 'react';

export interface FAQProps {
  nodes: NodesFAQ[];
}

interface FAQState {
  expandedNodes: string[];
}

interface NodesFAQ {
  nodes: FAQItem[];
  uuid: string;
}

interface FAQItem {
  id: string;
  question: string;
  answer: string | ReactNode;
}

export default class FAQ extends React.Component<FAQProps, FAQState> {
  constructor(props) {
    super(props);
    this.state = {
      expandedNodes: [],
    };
  }

  private handleOnClick = (id) => {
    const index = this.state.expandedNodes.indexOf(id);
    const newExpandedNodes = [...this.state.expandedNodes];
    if (index === -1) {
      newExpandedNodes.push(id);
    } else {
      newExpandedNodes.splice(index, 1);
    }
    this.setState({ expandedNodes: newExpandedNodes });
  };

  render() {
    return (this.props.nodes || []).map((nodes, idx) => {
      const nodeFaqs: FAQItem[] = nodes.nodes || ([] as FAQItem[]);
      return (
        <div key={idx}>
          {nodeFaqs.map((nodeFaq) => {
            const isExpanded =
              this.state.expandedNodes.indexOf(nodeFaq.id) !== -1;
            return (
              <div key={nodeFaq.id} className="FAQ__questionBox">
                <div
                  className="FAQQuestion"
                  onClick={() => this.handleOnClick(nodeFaq.id)}
                >
                  <button
                    className="FAQQuestion__button"
                    tabIndex={0}
                    type="button"
                    aria-expanded={isExpanded}
                    aria-controls={`faq-answer-${nodeFaq.id}`}
                  >
                    <span id={`faq-question-${nodeFaq.id}`}>
                      {nodeFaq.question}
                    </span>
                    <Icon
                      variant={
                        isExpanded ? IconVariant.Minus : IconVariant.Plus
                      }
                    />
                  </button>
                </div>
                <div
                  id={`faq-answer-${nodeFaq.id}`}
                  className={classnames('FAQAnswer', {
                    'FAQAnswer--visible': isExpanded,
                  })}
                  role="region"
                  aria-labelledby={`faq-question-${nodeFaq.id}`}
                >
                  <Richtext html={true}>{nodeFaq.answer}</Richtext>
                </div>
              </div>
            );
          })}
        </div>
      );
    });
  }
}
